import { Point } from "./schemas";
import { MindmapNodeElement, MindmapNodeOrientation, mindmapNodeSchema } from "./schemas/mindmap";
import { canvasElementPrefix, createElementId, dbKey, getUnixTimestampUTC, textEnabledDefaults } from "../util/utils";
import { ReadTransaction } from "@workcanvas/reflect";

export function placeMindMapNode(
  { x, y }: Point,
  { rootId, parentId, nodeSize }: { rootId?: string; parentId?: string; nodeSize: { width: number; height: number } }
) {
  const id = createElementId();
  const fullId = dbKey(id, "mindmap");
  return {
    id,
    node: mindmapNodeSchema.parse({
      type: "mindmap",
      x,
      y,
      ...nodeSize,
      nodes: [],
      orientation: MindmapNodeOrientation.VERTICAL,
      zIndexLastChangeTime: getUnixTimestampUTC(),
      rootId: rootId ?? fullId, // if rootId is not provided, this is the root
      parentId,
      sortIndex: 0,
      collapsed: false,
      ...textEnabledDefaults,
    }) as MindmapNodeElement,
  };
}

export async function getMindmapNodesForRootId(tx: ReadTransaction, { rootId }: { rootId: string }) {
  const mindmapNodes = await tx
    .scan({ prefix: canvasElementPrefix + "mindmap" })
    .entries()
    .toArray();
  return mindmapNodesForData(mindmapNodes, rootId);
}

export function mindmapNodesForData(mindmapNodes: any[], rootId: string) {
  const nodes: { [key: string]: MindmapNodeElement } = mindmapNodes
    .filter(([, node]) => {
      const element = node as MindmapNodeElement;
      return element.hidden !== true && element.rootId === rootId;
    })
    .reduce((acc, [id, node]) => {
      const [, type, nodeId] = id.split("-");
      const newId = `${type}-${nodeId}`;
      acc[newId] = node as MindmapNodeElement;
      return acc;
    }, {});
  const nodesSizes = Object.entries(nodes).reduce((acc, [id, node]) => {
    acc[id] = { width: node.width, height: node.height };
    return acc;
  }, {} as { [key: string]: { width: number; height: number } });
  return { nodes, nodesSizes };
}
